import { initialize } from 'redux-form';
import { FORM_NAME } from '../Form';
import { getProps } from '../props';
import {getProjectTotalsPost} from "../../../HttpRequests/projects";
import {omit} from "lodash";
import {loadProjectTotals} from "../State/projectTotals";
import onChangeClient from '../Handlers/onChangeClient';

export default () => async (dispatch) => {

  const { project, loadClientId } = getProps();

  if (project) {

    dispatch(initialize(FORM_NAME, project))

    const totalParams = {};

    totalParams['filter[profit_and_loss]'] = 1;
    totalParams['filter[id]'] = [project.id];

    const getProjectTotalsResponse = await getProjectTotalsPost({ params: omit(totalParams, []) });
    dispatch(loadProjectTotals(getProjectTotalsResponse.data.data));

  } else {

      let initialData = {};
      if (loadClientId > 0)
          initialData['client_id'] = loadClientId;

      dispatch(initialize(FORM_NAME, initialData))
      dispatch(onChangeClient(null, loadClientId));
  }

}
